import axios from 'axios';
import { errorInteractions } from '../../analytics';

export const getRecommendedToeKicks = async (host, designPayloadParam, toeKickSuperSkuId) => {
  const errorMsg = 'Get Recommended Toe Kicks: Request failed';

  try {
    const response = await axios.post(
      `${host}/api/modulardesigner/calculator/numberOfToeKicks`,
      {
        CabinetDesignPayload: {
          Products: designPayloadParam
        },
        ToeKickSuperSkuId: String(toeKickSuperSkuId)
      }
    );

    if (response?.status === 200) {
      return parseInt(response?.data?.content ?? '0', 10);
    }
    throw new Error(errorMsg);
  } catch (err) {
    const errorObject = {
      type: 'catastrophic',
      displayType: 'inline',
      pageSection: 'Get Recommended Toe Kicks',
      message: errorMsg,
    };
    const trackErrorInteractions = { errorObject, primaryCategory: 'error', eventName: 'post page error' };
    errorInteractions(trackErrorInteractions);
    return 0;
  }
};
